<external-content-wrapper>
  <router-outlet></router-outlet>
</external-content-wrapper>
